import { useCallback } from 'react'

import { Bill } from '../types/bill'

interface UseRegisterBillPaymentProps {
  bill?: Bill
  openReconciliationModal?: () => void
}

export const useRegisterBillPayment = ({ bill, openReconciliationModal }: UseRegisterBillPaymentProps) => {
  const handleRegisterPayment = useCallback(() => {
    if (!bill) {
      return
    }
    openReconciliationModal?.()
  }, [bill, openReconciliationModal])

  return {
    handleRegisterPayment,
  }
}
